import React, { useContext } from 'react';

import cx from 'classnames';

import ItemLink from 'components/Layouts/Admin/Dashboard/Navigation/ItemLink';
import { FlightsContext } from 'components/Pages/Admin/GuestPortal/Flights/context';
import Icon from 'components/shared/Icon';
import Pencil from 'components/shared/Icon/icons/Pencil';
import Trash from 'components/shared/Icon/icons/Trash';
import tableStyles from 'components/shared/Table/index.module.css';
import TableMenu from 'components/shared/TableMenu';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { isInternalItem } from 'store/itinerariesItem';

import { DatePickerButton } from '../DatePickerButton';
import { DetailsAndNotes } from '../DetailsAndNotes';
import s from './index.module.css';

export function RowContent(props) {
  const { isMobile } = useMediaBreakpoints();
  const { withoutMenu, item, itemIndex, isReadonly, isPDF, dateFormat } = props;
  const {
    handleItemChange,
    handleItemRemove,
    checkPolicy,
    agentBlockedContentClick,
    handleItemBlur,
    handleOpenEditModal,
  } = useContext(FlightsContext);
  const canDestroy = checkPolicy ? item?.policies?.destroy : true;
  const canUpdate = checkPolicy ? item?.policies?.update : true;
  const isAgentBlockedContent = checkPolicy && !item?.policies?.destroy && !item?.policies?.update;
  const isEmpty = isInternalItem(item);

  return (
    <tr
      className={s.tr}
      data-id={item?.id}
      onClick={() => agentBlockedContentClick && agentBlockedContentClick(isAgentBlockedContent)}
    >
      <td style={{ width: '1px' }}>
        {withoutMenu && !isReadonly && (
          <div className={cx(s.iconsCell, 'custom-flights-icons-cell')}>
            {canUpdate && (
              <Icon
                component={Pencil}
                className={cx(s.icon, s.iconEdit)}
                onClick={() => {
                  if (isReadonly) return;
                  handleOpenEditModal(itemIndex);
                }}
              />
            )}

            {canDestroy && (
              <Icon
                component={Trash}
                className={cx(s.icon)}
                onClick={() => {
                  if (isReadonly) return;
                  handleItemRemove(item.id);
                }}
              />
            )}
          </div>
        )}
      </td>

      <td className={cx(tableStyles.cell, tableStyles.cellTd, 'tdContent custom-flights-td')}>
        <DatePickerButton
          item={item}
          itemIndex={itemIndex}
          onChange={handleItemChange}
          isReadonly={isReadonly || !canUpdate}
          dateFormat={dateFormat}
        />
      </td>
      <td
        colSpan={isMobile ? 1 : 2}
        className={cx(tableStyles.cell, tableStyles.cellTd, 'tdContent custom-flights-td')}
      >
        <DetailsAndNotes
          item={item}
          itemIndex={itemIndex}
          onChange={handleItemChange}
          isReadonly={isReadonly || !canUpdate}
          onBlur={handleItemBlur}
          isPDF={isPDF}
          dateFormat={dateFormat}
        />
      </td>

      <td style={{ position: 'relative', width: '8px' }}>
        {!withoutMenu && (
          <TableMenu
            isFixed
            placementParams={{ anchor: 'BOTTOM_CENTER', triggerOffset: 15 }}
            iconClassName={s.menuIcon}
            renderCell={({ toggle, className, icon }) => {
              return (
                <div className={cx(className, s.divIcon)} onClick={toggle}>
                  {icon}
                </div>
              );
            }}
          >
            {({ close }) => {
              return (
                <>
                  <ItemLink
                    isButton
                    isDropdown
                    onClick={() => {
                      handleItemRemove(item.id);
                      close();
                    }}
                  >
                    <div style={{ color: 'var(--text_color-critical)' }}>Delete</div>
                  </ItemLink>
                  {!isEmpty && (
                    <ItemLink
                      isButton
                      isDropdown
                      onClick={() => {
                        handleOpenEditModal(itemIndex);
                        close();
                      }}
                    >
                      Edit
                    </ItemLink>
                  )}
                </>
              );
            }}
          </TableMenu>
        )}
      </td>
    </tr>
  );
}
